import { useQuery } from '@tanstack/react-query'
import { fetchAuditTrail } from '@/api/auditTrail'
import { queryKeys } from '@/lib/queryKeys'
import type { ChangeLogResponse } from '@/types'

export function useAuditTrail(
  planId: string | undefined,
  versionId: string | undefined | null,
  page: number = 1,
  pageSize: number = 20
) {
  return useQuery<ChangeLogResponse>({
    queryKey: queryKeys.auditTrail.byVersion(
      planId!,
      versionId!,
      page,
      pageSize
    ),
    queryFn: () => fetchAuditTrail(planId!, versionId!, page, pageSize),
    enabled: !!planId && !!versionId,
    refetchOnMount: 'always',
    gcTime: 0,
  })
}
